import { Datetime } from '@virtidev/toolbox';
import { useMemo } from 'react';
import StyledLink from '../../../../../../../styled-components/StyledLink';
import { DeletedUserText } from '../DashboardUsagePanel.styled';

export const UsageSubmissionItem = ({ item }) => {
  const {
    ID,
    Created,
    Member: { ID: userId, Name, UserType },
    FeedbackForm: { ID: formId, Title },
  } = item;

  const userLink = useMemo(() => {
    if (userId === '0' || !userId || UserType === 'public') {
      return <DeletedUserText>(Public user)</DeletedUserText>;
    }
    return (
      <StyledLink to={`/users/${userId}`} title={Name || null}>
        {Name || <DeletedUserText>(No name)</DeletedUserText>}
      </StyledLink>
    );
  }, [userId, UserType, Name]);

  const itemLink = useMemo(
    () =>
      formId ? (
        <StyledLink
          to={{
            pathname: `/analytics-data/forms/${formId}`,
            search: `tab=submissions&submission=${ID}`,
          }}
          title={Title || null}
        >
          {Title || <DeletedUserText>(No title)</DeletedUserText>}
        </StyledLink>
      ) : (
        <DeletedUserText>(Deleted)</DeletedUserText>
      ),
    [formId, Title, ID]
  );

  return (
    <div>
      {userLink} submitted to {itemLink}{' '}
      <Datetime datetime={Created} long difference={24 * 7} />
    </div>
  );
};

export default UsageSubmissionItem;
